import PropTypes from "prop-types";
import { useInView } from "react-intersection-observer";

import { Map, Marker } from "@components/map";

export function MapWrapper({ points }) {
  const { ref, inView } = useInView({
    threshold: 1,
    triggerOnce: true,
  });

  return (
    <div className="w-full h-full rounded bg-black-100" ref={ref}>
      {inView && (
        <Map>
          {points.map((poi, i) => (
            <Marker
              lat={poi.meta.coords.lat}
              lng={poi.meta.coords.lon}
              index={i + 1}
              color={poi.primary ? "bg-blue" : "bg-black-300"}
              key={poi.esid}
            />
          ))}
        </Map>
      )}
    </div>
  );
}

MapWrapper.propTypes = {
  points: PropTypes.arrayOf(
    PropTypes.shape({
      coordinates: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lon: PropTypes.number.isRequired,
      }),
    })
  ).isRequired,
};
